export default {
    GETCITIES: '@_get_cities',
    ADDCITY: '@_add_city',
    SINGLECITY: '@_get_single_city',
    DELETECITY: '@_delete_city',
    EDITCITY: '@_edit_city',
};
